import React from 'react';

interface ManagerDetailsMenuProps {
  // id: string;
  onAssignHouse: () => void;
  onDeleteManager: () => void;
}

export const ManagerDetailsMenu: React.FC<ManagerDetailsMenuProps> = ({
  // id,
  onAssignHouse,
  onDeleteManager,
}) => {
  // --- Define menu items dynamically ---
  const menuItems = [
    {
      label: 'Assign houses',
      onClick: onAssignHouse,
      icon: (
        <svg
          width="19"
          height="20"
          viewBox="0 0 19 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 18H14.5V15.5H17V14.5H14.5V12H13.5V14.5H11V15.5H13.5V18ZM14 20C12.6167 20 11.4375 19.5125 10.4625 18.5375C9.4875 17.5625 9 16.3833 9 15C9 13.6167 9.4875 12.4375 10.4625 11.4625C11.4375 10.4875 12.6167 10 14 10C15.3833 10 16.5625 10.4875 17.5375 11.4625C18.5125 12.4375 19 13.6167 19 15C19 16.3833 18.5125 17.5625 17.5375 18.5375C16.5625 19.5125 15.3833 20 14 20ZM0 18V6L8 0L16 6V8.3C15.6833 8.2 15.3583 8.125 15.025 8.075C14.6917 8.025 14.35 8 14 8V7L8 2.5L2 7V16H7.075C7.125 16.35 7.2 16.6917 7.3 17.025C7.4 17.3583 7.525 17.6833 7.675 18H0Z"
            fill="#474747"
          />
        </svg>
      ),
    },
    {
      label: 'Delete House Manager',
      onClick: onDeleteManager,
      icon: (
        <svg
          width="16"
          height="18"
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 18C2.45 18 1.97917 17.8042 1.5875 17.4125C1.19583 17.0208 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8042 17.0208 14.4125 17.4125C14.0208 17.8042 13.55 18 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
            fill="#E03A3D"
          />
        </svg>
      ),
      danger: true,
    },
  ];

  // --- Render dynamically ---
  return (
    <div className="relative inline-block text-left">
      <div className="absolute right-0 mt-15 w-72 origin-top-right bg-white border border-gray-200 shadow-lg focus:outline-none z-50 rounded-lg">
        <div className="py-1 text-base md:text-xl">
          {menuItems.map(({ label, icon, onClick, danger }) => (
            <div
              key={label}
              onClick={onClick}
              className={`w-full text-left p-2 md:p-4 flex items-center gap-4 transition-colors cursor-pointer hover:bg-gray-100 ${
                danger ? 'text-red-600' : 'text-text-primary'
              }`}
            >
              {icon}
              <span>{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
